import Form from './form'

export default {
  icon: 'arrow-right',
  label: 'Redirect',
  type: 'voice',
  action: 'redirect',
  form: Form,
  token: ({ destination }) => destination
}
